import React, { FormEvent, FunctionComponent, useCallback, useState } from 'react'
import styled from 'styled-components'
import Column from '../../../../../components/Column'
import Row from '../../../../../components/Row'
import Text from '../../../../../components/Text'
import { useAuthHandlers } from '../../../../../services/actions/auth/useAuthHandlers'
import { useAuthStore } from '../../../../../stores/auth/useAuthStore'
import { styles } from '../../../../../styles/themes/style'
import ToggleButton from '../../../../../components/ToggleButton'
import { useAuthActions } from '../../../../../stores/auth/useAuthActions'

interface IPreferencesProps { }

const Preferences: FunctionComponent<IPreferencesProps> = () => {
    const { saveUserPreferencesHandler } = useAuthHandlers()
    const { setUser } = useAuthActions() 
    const { store: { user } } = useAuthStore()

    const setCrispChat = async (e: any, boolean: boolean) => {
      saveUserPreferencesHandler({crispChat: boolean})

      setUser({...user, preferences: { ...user?.preferences, crispChat: boolean }})
    }

    return <>
      <StyledColumn gap="40px">
        <StyledRow spaceBetween gap='40px'>
          <Column gap='16px'>
              <Text $label $capitalize>{'Crisp Chat'}</Text>
              <Text $lighter>
              {'Show or hide Crisp chat.'}
              </Text>
          </Column>
          <ToggleButton onClickHandler={setCrispChat} value={user?.preferences?.crispChat ?? true} />
        </StyledRow>
      </StyledColumn>
      <MobileContainer>
        <StyledColumnMobile>
          <StyledColumnMobile>
            <StyledRowMobile>
                <Text $label $capitalize>{'Crisp Chat'}</Text>
            </StyledRowMobile>
          </StyledColumnMobile>
          <StyledColumnMobile>
            <Text $lighter>
                {'Show or hide Crisp chat.'}
            </Text>
          </StyledColumnMobile>
        </StyledColumnMobile>
        <Divider />
        <StyledColumnMobile>
          <StyledRowMobile>
              <ToggleButton onClickHandler={setCrispChat} value={user?.preferences?.crispChat ?? true} />
          </StyledRowMobile>
        </StyledColumnMobile>
      </MobileContainer>
    </>
}

const StyledRow = styled(Row)`
    @media (max-width: 786px) {
        display: none;
    }
`
const StyledColumn = styled(Column)`
    @media (max-width: 786px) {
        display: none;
    }
`
const MobileContainer = styled.div`
    display: none;
    width: 100%;

    @media (max-width: 786px) {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
`
const StyledRowMobile = styled(Row)`
    display: none;
    @media (max-width: 786px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
`
const StyledColumnMobile = styled(Column)<{ marginTop?: string }>`
    display: none;
    @media (max-width: 786px) {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        margin-top: ${({marginTop}) => marginTop ? marginTop : '0px' };
    }
`    
const Divider = styled.div`
  height: 2px;
  margin: 0px 8x 0px 8px;
  background-color: ${styles.colors.uiBackground};
`;
export default Preferences
